// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
WebFont.load({
    // google: { // add &display=swap to end of every font family
    //     families: ['Roboto:400,500,700&display=swap']
    // },
    typekit: {
        id: 'oow3sjg'
    },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true 
    }
});

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');

//Load Modules
require('./modules/accordion');
require('./modules/animatein');
require('./modules/bannerVideo');
require('./modules/formInputs');
require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/modal');
require('./modules/scrollTo');
require('./modules/searchToggle');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/tabs');


$(function() {
    var header = $('.header');
    var headerHeight = $('.header').outerHeight();
    var body = $('body');
    var headerAuxNav = $('.headerAuxNav');
    if (window.innerWidth > 992) {
        if ($(window).scrollTop() > headerHeight) {
            header.addClass('__sticky');
            body.css('margin-top',headerHeight + 'px');
            headerAuxNav.removeClass('d-lg-block');
        }
        $(window).on('scroll', function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > headerHeight && !header.hasClass('__sticky')) {
                header.addClass('__sticky');
                body.css('margin-top',headerHeight + 'px');
                headerAuxNav.removeClass('d-lg-block');
            } else if (scrollTop < headerHeight && header.hasClass('__sticky')) {
                header.removeClass('__sticky');
                body.css('margin-top','0');
                headerAuxNav.addClass('d-lg-block');
            }
        });
    }
});